"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullscreenOverlay = void 0;
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
var react_transition_group_1 = require("react-transition-group");
var common_1 = require("../../common");
require("./FullscreenOverlay.css");
var FullscreenOverlay = function (props) {
    var targetElement = React.useContext(common_1.OverlayContext).overlay;
    // Intentionally destructured from mergedProps
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _a = (0, common_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-fullscreen-overlay",
    }), children = _a.children, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, toggle = _a.toggle, mergedProps = __rest(_a, ["children", "isOpen", "toggle"]);
    // A ref passed in to CSSTransition so it doesn't need to use findDOMNode
    var nodeRef = React.useRef(null);
    var updatedProps = __assign(__assign({}, mergedProps), { ref: nodeRef });
    var content = (React.createElement(react_transition_group_1.CSSTransition, { nodeRef: nodeRef, in: isOpen, timeout: 150, classNames: "anim", mountOnEnter: true, unmountOnExit: true },
        React.createElement("div", __assign({}, updatedProps), children)));
    return targetElement ? ReactDOM.createPortal(content, targetElement) : null;
};
exports.FullscreenOverlay = FullscreenOverlay;
exports.default = exports.FullscreenOverlay;
